import { Panel } from '@assets/component/Panel/Panel';
import { PanelHeader } from '@assets/component/Panel/PanelHeader/PanelHeader';
import {
    PanelColumn,
    PanelRow,
    PanelTable
} from '@assets/component/Panel/PanelTable/PanelTable';
import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { noFormat } from '../PanelCompanyYearly/PanelElements/Formatters';
import { RowEditor } from '../PanelCompanyYearly/PanelElements/RowEditor/RowEditor';
import { RowLabel } from '../PanelCompanyYearly/PanelElements/RowLable/RowLable';
import { RowValue } from '../PanelCompanyYearly/PanelElements/RowValue/RowValue';
import { onEditReportField } from '../PanelCompanyYearly/UpdateFieldsUtil';
import { GetSectionIconUrl } from '@assets/component/SectionIcons/SectionIcon';

export const PanelBusinessOverview = observer(() => {
    const store = useStore();
    const query = store.query;
    const data = query.activeReport;

    if (!data) {
        return null;
    }

    const cols: PanelColumn[] = [
        {
            column: { source: null, display: 'Value' }
        },
        {
            column: { source: null, display: 'Source' },
            element: RowValue.sources,
            editor: RowEditor.textbox,

            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];

    const genRow = (
        fieldName: string,
        display: string,
        formatter: (d: any) => string,
        extra?: any
    ) => {
        return {
            editable: true,
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, column) => {
                return query.value(fieldName);
            },
            formatter,
            label: RowLabel.percent_label,
            element: RowValue.percent,
            ...extra
        };
    };
    //    var industry =
    //    query.value('industry') + ', ' + query.value('industrySubType');

    const editableFields = [
        { field: 'company_name', display: 'Company Name' },
        { field: 'company_ceo', display: 'Company CEO' },
        { field: 'hq_location', display: 'HQ Location' },
        { field: 'year_founded', display: 'Year Founded' }
    ];
    const rows: PanelRow[] = editableFields.map(e => {
        return genRow(e.field, e.display, noFormat, {
            editor: RowEditor.textbox
        });
    });

    return (
        <Panel shadow={true}>
            <PanelHeader title="Business Overview" />
            <PanelTable
                columns={cols}
                rows={rows}
                onEditField={onEditReportField}
            />
        </Panel>
    );
});
